import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Dialog from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/Dialog';
import DialogTitle from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogTitle';
import { withDialogState } from '../../../Common/Dialog/DialogWorkflow';
import ShippingAddressForm from './ShippingAddressForm';

const notAllowedToClose = () => {};

const ShippingAddressDialog = ({
  open, isOpen, onSubmit, isInitialSetup, onCancel, dialogTitle, invalid
}) => {
  const [errorMessage, setErrorMessage] = useState('');

  return (
    <Dialog
      onClose={notAllowedToClose}
      open={open}
      fullWidth
      maxWidth="sm"
      onExited={() => setErrorMessage('')}
    >
      <DialogTitle>
        {dialogTitle || "Shipping Address"}
      </DialogTitle>

      <ShippingAddressForm
        open={isOpen}
        setErrorMessage={setErrorMessage}
        errorMessage={errorMessage}
        onSubmit={onSubmit}
        disableCancel={isInitialSetup}
        onCancel={onCancel}
        invalid={invalid}
      />
    </Dialog>
  );
};

ShippingAddressDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isInitialSetup: PropTypes.bool.isRequired,
  onCancel: PropTypes.func,
  dialogTitle: PropTypes.string,
  invalid: PropTypes.bool
};

export default withDialogState()(ShippingAddressDialog);
